/**
 * The whole switch-to-text distance, in spacing steps — Figma's `switch/spacing`. The theme negates the
 * halo's padding, so nothing else sits between the two.
 */
export const SWITCH_LABEL_GAP = 0.75;

/** One label type at both sizes: Figma's small switch keeps the medium one's 14/20 label. */
export const SWITCH_LABEL_VARIANT = "body2";
